// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v7.34.0
// source: state.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "schedule";

export enum WizardMode {
  WIZARD_MODE_UNSPECIFIED = 0,
  WIZARD_MODE_BASIC = 1,
  WIZARD_MODE_ADVANCED = 2,
  UNRECOGNIZED = -1,
}

export enum CourseLevelBucket {
  COURSE_LEVEL_UNDERGRAD = 0,
  COURSE_LEVEL_GRAD = 1,
  UNRECOGNIZED = -1,
}

export enum CourseLanguageBucket {
  COURSE_LANGUAGE_EN = 0,
  COURSE_LANGUAGE_FR = 1,
  COURSE_LANGUAGE_OTHER = 2,
  UNRECOGNIZED = -1,
}

export enum DayOfWeek {
  DAY_MONDAY = 0,
  DAY_TUESDAY = 1,
  DAY_WEDNESDAY = 2,
  DAY_THURSDAY = 3,
  DAY_FRIDAY = 4,
  DAY_SATURDAY = 5,
  DAY_SUNDAY = 6,
  UNRECOGNIZED = -1,
}

/**
 * Mirror of the shared TS optimization-priorities model (`@uoplan/core`).
 * Stored as an ordered list (index 0 = highest priority).
 */
export enum OptimizationKind {
  OPTIMIZATION_KIND_UNSPECIFIED = 0,
  OPTIMIZATION_KIND_FREE_DAYS = 1,
  OPTIMIZATION_KIND_GOOD_BREAKS = 2,
  OPTIMIZATION_KIND_COMPACT = 3,
  OPTIMIZATION_KIND_PREFER_EASIER = 4,
  OPTIMIZATION_KIND_PREFER_SENTIMENT = 5,
  OPTIMIZATION_KIND_PREFER_PROFESSOR_RATING = 6,
  UNRECOGNIZED = -1,
}

export interface RequirementOptionSelection {
  reqIndex: number;
  optionIndex: number;
}

export interface RequirementCourseSelection {
  reqIndex: number;
  courseIndices: number[];
}

export interface ScheduleSwap {
  enrollmentIndex: number;
  courseCodeIndex: number;
}

export interface RequirementGroupSelection {
  reqIndex: number;
  groupPrefixIndices: number[];
}

export interface RequirementPriority {
  reqIndex: number;
  priority: number;
}

export interface BlockedTime {
  day: DayOfWeek;
  startMinutes: number;
  endMinutes: number;
}

export interface OptimizationPriority {
  kind: OptimizationKind;
  enabled: boolean;
  breakCount: number;
  breakTargetMinutes: number;
}

export interface ShareableState {
  wizardMode: WizardMode;
  basicPinnedCourses: number[];
  additionalElectivesCount: number;
  basicExcludedCategoryIndices: number[];
  selectedTermId?: number | undefined;
  firstYear?: number | undefined;
  programIndex?: number | undefined;
  minorProgramIndex?: number | undefined;
  studentProgramIndices: number[];
  /**
   * Course indices into `indices.pb` (OPT_SENTINEL_BASE-offset values encode OPT
   * courses). Plain packed indices: pre-2.x payloads bit-packed two 16-bit
   * indices per uint32, which the bumped STATE_MAGIC now rejects.
   */
  completedCourses: number[];
  levelBuckets: CourseLevelBucket[];
  languageBuckets: CourseLanguageBucket[];
  electiveLevelBuckets: number[];
  coursesThisSemester: number;
  /** Obsolete: uint32 selected_schedule_index = 15; */
  firstSeed: number;
  currentSeed: number;
  optionSelections: RequirementOptionSelection[];
  courseSelections: RequirementCourseSelection[];
  constrainedSelections: RequirementCourseSelection[];
  touchedReqIndices: number[];
  includeClosedComponents: boolean;
  virtualSectionsOnly: boolean;
  generationMinStartMinutes: number;
  generationMaxEndMinutes: number;
  generationAllowedDays: DayOfWeek[];
  generationLimitFirstYearCredits: boolean;
  magic: number;
  activeStep: number;
  swaps: ScheduleSwap[];
  showCalendar: boolean;
  constrainedGroupSelections: RequirementGroupSelection[];
  frenchImmersionStream: boolean;
  calendarWeekIndex?: number | undefined;
  blacklistedCourses: number[];
  blockedTimes: BlockedTime[];
  requirementPriorities: RequirementPriority[];
  /**
   * Ordered optimization objectives (index 0 = highest priority). Single source
   * of truth for the soft generation objectives; replaces the removed booleans.
   */
  optimizationPriorities: OptimizationPriority[];
  /**
   * Which school this state belongs to. Deliberately NOT `optional`: proto3
   * scalars default to 0, and 0 is uOttawa (`SCHOOL_WIRE_IDS` in
   * `@uoplan/domain/school`), so every pre-existing `?s=` payload — which has no
   * field 44 at all — decodes to uOttawa without a STATE_MAGIC bump. Every
   * course/program index in this message is relative to that school's own
   * `indices.pb`, so this field must be read before any index is resolved.
   */
  school: number;
}

/**
 * --- OG-image share preview -------------------------------------------------
 *
 * A compact, index-based encoding of an already-generated schedule, embedded in
 * share URLs (the `?p=` query param) so the OG-image worker can render it
 * WITHOUT re-running schedule generation. All indices reference the term's
 * schedules dataset (`schedules.<term_id>.pb`), which both the web app and the
 * worker load:
 *   - course_index    → index into SchedulesData.schedules[]
 *   - component_index → index into the course's component keys, sorted ascending
 *   - section_index   → index into that component's sections[]
 * component_indices[i] and section_indices[i] form one (component, section)
 * pick; the two arrays are parallel and packed, avoiding per-section message
 * framing to keep the share payload as small as possible.
 */
export interface PreviewCourseSelection {
  courseIndex: number;
  componentIndices: number[];
  sectionIndices: number[];
}

export interface SchedulePreview {
  termId: number;
  courses: PreviewCourseSelection[];
}

function createBaseRequirementOptionSelection(): RequirementOptionSelection {
  return { reqIndex: 0, optionIndex: 0 };
}

export const RequirementOptionSelection: MessageFns<RequirementOptionSelection> = {
  encode(message: RequirementOptionSelection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reqIndex !== 0) {
      writer.uint32(8).uint32(message.reqIndex);
    }
    if (message.optionIndex !== 0) {
      writer.uint32(16).uint32(message.optionIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequirementOptionSelection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequirementOptionSelection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reqIndex = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.optionIndex = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseRequirementCourseSelection(): RequirementCourseSelection {
  return { reqIndex: 0, courseIndices: [] };
}

export const RequirementCourseSelection: MessageFns<RequirementCourseSelection> = {
  encode(message: RequirementCourseSelection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reqIndex !== 0) {
      writer.uint32(8).uint32(message.reqIndex);
    }
    writer.uint32(18).fork();
    for (const v of message.courseIndices) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequirementCourseSelection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequirementCourseSelection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reqIndex = reader.uint32();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.courseIndices.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.courseIndices.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseScheduleSwap(): ScheduleSwap {
  return { enrollmentIndex: 0, courseCodeIndex: 0 };
}

export const ScheduleSwap: MessageFns<ScheduleSwap> = {
  encode(message: ScheduleSwap, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enrollmentIndex !== 0) {
      writer.uint32(8).uint32(message.enrollmentIndex);
    }
    if (message.courseCodeIndex !== 0) {
      writer.uint32(16).uint32(message.courseCodeIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScheduleSwap {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScheduleSwap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enrollmentIndex = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.courseCodeIndex = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseRequirementGroupSelection(): RequirementGroupSelection {
  return { reqIndex: 0, groupPrefixIndices: [] };
}

export const RequirementGroupSelection: MessageFns<RequirementGroupSelection> = {
  encode(message: RequirementGroupSelection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reqIndex !== 0) {
      writer.uint32(8).uint32(message.reqIndex);
    }
    writer.uint32(18).fork();
    for (const v of message.groupPrefixIndices) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequirementGroupSelection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequirementGroupSelection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reqIndex = reader.uint32();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.groupPrefixIndices.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.groupPrefixIndices.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseRequirementPriority(): RequirementPriority {
  return { reqIndex: 0, priority: 0 };
}

export const RequirementPriority: MessageFns<RequirementPriority> = {
  encode(message: RequirementPriority, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reqIndex !== 0) {
      writer.uint32(8).uint32(message.reqIndex);
    }
    if (message.priority !== 0) {
      writer.uint32(16).uint32(message.priority);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RequirementPriority {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequirementPriority();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reqIndex = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.priority = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseBlockedTime(): BlockedTime {
  return { day: 0, startMinutes: 0, endMinutes: 0 };
}

export const BlockedTime: MessageFns<BlockedTime> = {
  encode(message: BlockedTime, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.day !== 0) {
      writer.uint32(8).int32(message.day);
    }
    if (message.startMinutes !== 0) {
      writer.uint32(16).uint32(message.startMinutes);
    }
    if (message.endMinutes !== 0) {
      writer.uint32(24).uint32(message.endMinutes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BlockedTime {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBlockedTime();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.day = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.startMinutes = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.endMinutes = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseOptimizationPriority(): OptimizationPriority {
  return { kind: 0, enabled: false, breakCount: 0, breakTargetMinutes: 0 };
}

export const OptimizationPriority: MessageFns<OptimizationPriority> = {
  encode(message: OptimizationPriority, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    if (message.breakCount !== 0) {
      writer.uint32(24).uint32(message.breakCount);
    }
    if (message.breakTargetMinutes !== 0) {
      writer.uint32(32).uint32(message.breakTargetMinutes);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OptimizationPriority {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptimizationPriority();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.breakCount = reader.uint32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.breakTargetMinutes = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseShareableState(): ShareableState {
  return {
    wizardMode: 0,
    basicPinnedCourses: [],
    additionalElectivesCount: 0,
    basicExcludedCategoryIndices: [],
    selectedTermId: undefined,
    firstYear: undefined,
    programIndex: undefined,
    minorProgramIndex: undefined,
    studentProgramIndices: [],
    completedCourses: [],
    levelBuckets: [],
    languageBuckets: [],
    electiveLevelBuckets: [],
    coursesThisSemester: 0,
    firstSeed: 0,
    currentSeed: 0,
    optionSelections: [],
    courseSelections: [],
    constrainedSelections: [],
    touchedReqIndices: [],
    includeClosedComponents: false,
    virtualSectionsOnly: false,
    generationMinStartMinutes: 0,
    generationMaxEndMinutes: 0,
    generationAllowedDays: [],
    generationLimitFirstYearCredits: false,
    magic: 0,
    activeStep: 0,
    swaps: [],
    showCalendar: false,
    constrainedGroupSelections: [],
    frenchImmersionStream: false,
    calendarWeekIndex: undefined,
    blacklistedCourses: [],
    blockedTimes: [],
    requirementPriorities: [],
    optimizationPriorities: [],
    school: 0,
  };
}

export const ShareableState: MessageFns<ShareableState> = {
  encode(message: ShareableState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.wizardMode !== 0) {
      writer.uint32(8).int32(message.wizardMode);
    }
    writer.uint32(18).fork();
    for (const v of message.basicPinnedCourses) {
      writer.uint32(v);
    }
    writer.join();
    if (message.additionalElectivesCount !== 0) {
      writer.uint32(24).uint32(message.additionalElectivesCount);
    }
    writer.uint32(34).fork();
    for (const v of message.basicExcludedCategoryIndices) {
      writer.uint32(v);
    }
    writer.join();
    if (message.selectedTermId !== undefined) {
      writer.uint32(40).uint32(message.selectedTermId);
    }
    if (message.firstYear !== undefined) {
      writer.uint32(48).uint32(message.firstYear);
    }
    if (message.programIndex !== undefined) {
      writer.uint32(56).uint32(message.programIndex);
    }
    if (message.minorProgramIndex !== undefined) {
      writer.uint32(64).uint32(message.minorProgramIndex);
    }
    writer.uint32(74).fork();
    for (const v of message.studentProgramIndices) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(82).fork();
    for (const v of message.completedCourses) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(90).fork();
    for (const v of message.levelBuckets) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(98).fork();
    for (const v of message.languageBuckets) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(106).fork();
    for (const v of message.electiveLevelBuckets) {
      writer.uint32(v);
    }
    writer.join();
    if (message.coursesThisSemester !== 0) {
      writer.uint32(112).uint32(message.coursesThisSemester);
    }
    if (message.firstSeed !== 0) {
      writer.uint32(128).uint32(message.firstSeed);
    }
    if (message.currentSeed !== 0) {
      writer.uint32(248).uint32(message.currentSeed);
    }
    for (const v of message.optionSelections) {
      RequirementOptionSelection.encode(v!, writer.uint32(138).fork()).join();
    }
    for (const v of message.courseSelections) {
      RequirementCourseSelection.encode(v!, writer.uint32(146).fork()).join();
    }
    for (const v of message.constrainedSelections) {
      RequirementCourseSelection.encode(v!, writer.uint32(154).fork()).join();
    }
    writer.uint32(162).fork();
    for (const v of message.touchedReqIndices) {
      writer.uint32(v);
    }
    writer.join();
    if (message.includeClosedComponents !== false) {
      writer.uint32(168).bool(message.includeClosedComponents);
    }
    if (message.virtualSectionsOnly !== false) {
      writer.uint32(176).bool(message.virtualSectionsOnly);
    }
    if (message.generationMinStartMinutes !== 0) {
      writer.uint32(184).uint32(message.generationMinStartMinutes);
    }
    if (message.generationMaxEndMinutes !== 0) {
      writer.uint32(192).uint32(message.generationMaxEndMinutes);
    }
    writer.uint32(202).fork();
    for (const v of message.generationAllowedDays) {
      writer.int32(v);
    }
    writer.join();
    if (message.generationLimitFirstYearCredits !== false) {
      writer.uint32(216).bool(message.generationLimitFirstYearCredits);
    }
    if (message.magic !== 0) {
      writer.uint32(232).uint32(message.magic);
    }
    if (message.activeStep !== 0) {
      writer.uint32(240).uint32(message.activeStep);
    }
    for (const v of message.swaps) {
      ScheduleSwap.encode(v!, writer.uint32(258).fork()).join();
    }
    if (message.showCalendar !== false) {
      writer.uint32(264).bool(message.showCalendar);
    }
    for (const v of message.constrainedGroupSelections) {
      RequirementGroupSelection.encode(v!, writer.uint32(274).fork()).join();
    }
    if (message.frenchImmersionStream !== false) {
      writer.uint32(288).bool(message.frenchImmersionStream);
    }
    if (message.calendarWeekIndex !== undefined) {
      writer.uint32(296).uint32(message.calendarWeekIndex);
    }
    writer.uint32(306).fork();
    for (const v of message.blacklistedCourses) {
      writer.uint32(v);
    }
    writer.join();
    for (const v of message.blockedTimes) {
      BlockedTime.encode(v!, writer.uint32(314).fork()).join();
    }
    for (const v of message.requirementPriorities) {
      RequirementPriority.encode(v!, writer.uint32(322).fork()).join();
    }
    for (const v of message.optimizationPriorities) {
      OptimizationPriority.encode(v!, writer.uint32(346).fork()).join();
    }
    if (message.school !== 0) {
      writer.uint32(352).uint32(message.school);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ShareableState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShareableState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.wizardMode = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.basicPinnedCourses.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.basicPinnedCourses.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.additionalElectivesCount = reader.uint32();
          continue;
        }
        case 4: {
          if (tag === 32) {
            message.basicExcludedCategoryIndices.push(reader.uint32());

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.basicExcludedCategoryIndices.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.selectedTermId = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.firstYear = reader.uint32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.programIndex = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.minorProgramIndex = reader.uint32();
          continue;
        }
        case 9: {
          if (tag === 72) {
            message.studentProgramIndices.push(reader.uint32());

            continue;
          }

          if (tag === 74) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.studentProgramIndices.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 10: {
          if (tag === 80) {
            message.completedCourses.push(reader.uint32());

            continue;
          }

          if (tag === 82) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.completedCourses.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 11: {
          if (tag === 88) {
            message.levelBuckets.push(reader.int32() as any);

            continue;
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.levelBuckets.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 12: {
          if (tag === 96) {
            message.languageBuckets.push(reader.int32() as any);

            continue;
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.languageBuckets.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 13: {
          if (tag === 104) {
            message.electiveLevelBuckets.push(reader.uint32());

            continue;
          }

          if (tag === 106) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.electiveLevelBuckets.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.coursesThisSemester = reader.uint32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.firstSeed = reader.uint32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.currentSeed = reader.uint32();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.optionSelections.push(RequirementOptionSelection.decode(reader, reader.uint32()));
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.courseSelections.push(RequirementCourseSelection.decode(reader, reader.uint32()));
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.constrainedSelections.push(RequirementCourseSelection.decode(reader, reader.uint32()));
          continue;
        }
        case 20: {
          if (tag === 160) {
            message.touchedReqIndices.push(reader.uint32());

            continue;
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.touchedReqIndices.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 21: {
          if (tag !== 168) {
            break;
          }

          message.includeClosedComponents = reader.bool();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.virtualSectionsOnly = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.generationMinStartMinutes = reader.uint32();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.generationMaxEndMinutes = reader.uint32();
          continue;
        }
        case 25: {
          if (tag === 200) {
            message.generationAllowedDays.push(reader.int32() as any);

            continue;
          }

          if (tag === 202) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.generationAllowedDays.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.generationLimitFirstYearCredits = reader.bool();
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.magic = reader.uint32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.activeStep = reader.uint32();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.swaps.push(ScheduleSwap.decode(reader, reader.uint32()));
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.showCalendar = reader.bool();
          continue;
        }
        case 34: {
          if (tag !== 274) {
            break;
          }

          message.constrainedGroupSelections.push(RequirementGroupSelection.decode(reader, reader.uint32()));
          continue;
        }
        case 36: {
          if (tag !== 288) {
            break;
          }

          message.frenchImmersionStream = reader.bool();
          continue;
        }
        case 37: {
          if (tag !== 296) {
            break;
          }

          message.calendarWeekIndex = reader.uint32();
          continue;
        }
        case 38: {
          if (tag === 304) {
            message.blacklistedCourses.push(reader.uint32());

            continue;
          }

          if (tag === 306) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.blacklistedCourses.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 39: {
          if (tag !== 314) {
            break;
          }

          message.blockedTimes.push(BlockedTime.decode(reader, reader.uint32()));
          continue;
        }
        case 40: {
          if (tag !== 322) {
            break;
          }

          message.requirementPriorities.push(RequirementPriority.decode(reader, reader.uint32()));
          continue;
        }
        case 43: {
          if (tag !== 346) {
            break;
          }

          message.optimizationPriorities.push(OptimizationPriority.decode(reader, reader.uint32()));
          continue;
        }
        case 44: {
          if (tag !== 352) {
            break;
          }

          message.school = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBasePreviewCourseSelection(): PreviewCourseSelection {
  return { courseIndex: 0, componentIndices: [], sectionIndices: [] };
}

export const PreviewCourseSelection: MessageFns<PreviewCourseSelection> = {
  encode(message: PreviewCourseSelection, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.courseIndex !== 0) {
      writer.uint32(8).uint32(message.courseIndex);
    }
    writer.uint32(18).fork();
    for (const v of message.componentIndices) {
      writer.uint32(v);
    }
    writer.join();
    writer.uint32(26).fork();
    for (const v of message.sectionIndices) {
      writer.uint32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PreviewCourseSelection {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePreviewCourseSelection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.courseIndex = reader.uint32();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.componentIndices.push(reader.uint32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.componentIndices.push(reader.uint32());
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag === 24) {
            message.sectionIndices.push(reader.uint32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.sectionIndices.push(reader.uint32());
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

function createBaseSchedulePreview(): SchedulePreview {
  return { termId: 0, courses: [] };
}

export const SchedulePreview: MessageFns<SchedulePreview> = {
  encode(message: SchedulePreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.termId !== 0) {
      writer.uint32(8).uint32(message.termId);
    }
    for (const v of message.courses) {
      PreviewCourseSelection.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SchedulePreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSchedulePreview();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.termId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.courses.push(PreviewCourseSelection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },
};

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
}
